// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3538":"f7cced5f","9474":"f7cced5f","9553":"f7cced5f"}[chunkId] + ".chunk.css";
};